import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import tabgrid from "../../../../../../utilities/TabGrid";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import acc from 'accounting'
import {Link} from "react-router-dom";
import {TopAlertInformacja} from "../../../../../../componentsTopsa/alerty/TopAlerts";

export default class PokazTabeleCenIZnizek extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    };

    renderRodz(cell,row){
        if(Boolean(cell)){
            return <span className={'label label-ebus-default'} style={{color:'#fff', background:row.kolor}}>{cell}</span>
           /* if(cell==='PROM'){
                return <span className={'label label-ebus-default'} style={{background:'dodgerblue', color:'white'}}>{cell}</span>
            }
            else{
                return <span className={'label label-ebus-default'}>{cell}</span>
            }*/
        }
    }

    renderCena(cell,row){
        if(Boolean(cell) || cell == 0){
            return acc.formatMoney(cell)
        }
    }

    renderEsprzedaz(cell,row){
        if(Boolean(cell)){
            return <div style={{color:'forestgreen', textAlign:'center'}} title={'dozwolona'}><i className={'fa fa-check'}></i></div>
        } else return <div style={{color:'firebrick', textAlign:'center'}} title={'brak możliwości'}><i className={'fa fa-times'}></i></div>
    }

    renderNazwaZnizki(cell,row){
        if(row.rodz==='PROM'){
            return (<div>
                <span>{cell}</span> <Link to={'/konfiguracja/zarzadzanie-biletami/promocje'}>
                <span style={{marginLeft:'5px', color:'dodgerblue'}}><i className={'fa fa-tag'}></i> Kod: {row.idPro}</span>
                </Link>
            </div>)
        }
        else return cell
    }

    render() {

        let options = {
           // sortName:'cena',
           // sortOrder:'desc',
            noDataText: 'Brak pasujących rekordów',

        }

        let esprzedaz = {
            true: 'tak',
            false: 'nie'
        }

        return (
            <div style={{marginTop: '15px'}}>
                <fieldset>
                    <div className={'fieldset-label'}>Ceny dla biletów {Boolean(this.props.czyJednorazowe)?'jednorazowych' : 'miesięcznych'}</div>
                    <Row>
                        <Col xs={12}>
                            <div>
                                {
                                    (this.props.czyJednorazowe)?
                                                Boolean(this.props.data.find(z=>Boolean(z.idPro)))?
                                                    <TopAlertInformacja text={'Ten kurs jest objęty promocją!'}/>
                                                    :
                                                    ''
                                        :
                                        ''
                                }
                            </div>
                            <div className={'bootstrapTableContainerNoMarginTop'}>
                            <BootstrapTable data={this.props.data}
                                            options={options}
                                            hover
                            >
                                <TableHeaderColumn dataField='rodz' isKey hidden={true}>rodz</TableHeaderColumn>
                                <TableHeaderColumn dataField='rodz' dataSort
                                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                   dataFormat={this.renderRodz}
                                >Rodzaj</TableHeaderColumn>
                                <TableHeaderColumn dataField='nazZniz' dataSort
                                                   thStyle={tabgrid.tg8} tdStyle={tabgrid.tg8}  dataFormat={(cell,row)=><span style={{fontSize:12}}>{cell}</span>}
                                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                                   dataFormat={this.renderNazwaZnizki}
                                >Nazwa zniżki</TableHeaderColumn>
                                <TableHeaderColumn dataField='proc' dataSort
                                                   thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                                   filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                >%</TableHeaderColumn>
                                <TableHeaderColumn dataField='cena' dataSort
                                                   thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                                   filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                                   dataFormat={this.renderCena}
                                >Cena</TableHeaderColumn>
                                <TableHeaderColumn dataField='uoperatora' dataSort
                                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                                   filter={ { type: 'SelectFilter', options: esprzedaz, selectText: '' } } formatExtraData={ esprzedaz }
                                                   dataFormat={this.renderEsprzedaz}
                                >u op.</TableHeaderColumn>
                                <TableHeaderColumn dataField='esprzedaz' dataSort
                                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                                   filter={ { type: 'SelectFilter', options: esprzedaz, selectText: '' } } formatExtraData={ esprzedaz }
                                                   dataFormat={this.renderEsprzedaz}
                                >e-sprz.</TableHeaderColumn>
                                <TableHeaderColumn dataField='ukierowcy' dataSort
                                                   thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                                   filter={ { type: 'SelectFilter', options: esprzedaz, selectText: '' } } formatExtraData={ esprzedaz }
                                                   dataFormat={this.renderEsprzedaz}
                                >u kier.</TableHeaderColumn>
                            </BootstrapTable>
                            </div>
                        </Col>
                    </Row>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/cenyBiletow/pokażCenyZeZnizkami/components/PokazTabeleCenIZnizek.js